import { classnames } from 'Utils/classnames/classnames.utils';

import { getCursorClass } from 'Components/utils/form/form.util';

export const themes = {
  default: (props) => ({
    thInputWrapper: 'flex flex-1 h-full items-center relative',
    thInput: classnames('h-full w-full text-center text-current', getCursorClass(props)),
  }),
};
